import { fetch } from '@atlassian/eoc-fetch';

import {
	type CustomRoleFormValues,
	type CustomRoleResponse,
	type CustomRolesListResponse,
	type PermissionsResponse,
} from '../../../common/types';

export const getPermissionsEndpoint = (): Promise<PermissionsResponse> =>
	fetch<PermissionsResponse>(`/v1/users/permissions`);

export const createCustomRoleEndpoint = (
	newCustomRole: CustomRoleFormValues,
): Promise<CustomRoleResponse> =>
	fetch<CustomRoleResponse>(`/v1/users/roles`, {
		method: 'POST',
		body: newCustomRole,
	});

export const editCustomRoleEndpoint = (
	updatedCustomRole: CustomRoleResponse,
): Promise<CustomRoleResponse> => {
	const { id } = updatedCustomRole;
	return fetch<CustomRoleResponse>(`/v1/users/roles/${id}`, {
		method: 'PATCH',
		body: updatedCustomRole,
	});
};

export const deleteCustomRoleEndpoint = (
	id: string,
): Promise<{
	success: boolean;
}> => {
	return fetch<{ success: boolean }>(`/v1/users/roles/${id}`, {
		method: 'DELETE',
	});
};

export const getCustomRolesListEndpoint = (): Promise<CustomRolesListResponse> =>
	fetch<CustomRolesListResponse>(`/v1/users/roles`);
